import { object, string, array, boolean } from '@gogame/schemas';

import {
  COLUMN_REGS,
  COLUMN_DEPOSITS,
  COLUMN_DEPOSIT_AMOUNT,
  COLUMN_DEPOSIT_AMOUNT_GROSS,
  COLUMN_SUBSCRIPTIONS,
  COLUMN_FREE_TRIALS,
} from '../constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_REGS,
    COLUMN_DEPOSITS,
    COLUMN_DEPOSIT_AMOUNT,
    COLUMN_DEPOSIT_AMOUNT_GROSS,
    COLUMN_SUBSCRIPTIONS,
    COLUMN_FREE_TRIALS,
  ]),
  percentage: array(string()).default([]),
  collapsed: array(string()).default([]),
  scaled: array(string()).default([]),
  isAllScaled: boolean().default(false),
});
